import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import type { SelectChangeEvent } from '@mui/material'
import type { TFunction } from 'i18next'
import { DAY_TRANSLATION_KEYS, WEEK_DAYS } from 'shared/utils/schedule'
import { ScheduleSetTimeCaption } from '../ScheduleSetTimeCaption'
import { DateFieldInputRow } from '../ScheduleFields.style'
import { fieldCaptionLabelSx } from '../ScheduleFields.utils'

export type DaySelectProps = {
  disabled: boolean
  fieldId: string
  caption: string
  value: string
  onChange: (event: SelectChangeEvent<string>) => void
  t: TFunction
  footerCaption?: string | null
}

export function DaySelect({
  disabled,
  fieldId,
  caption,
  value,
  onChange,
  t,
  footerCaption,
}: DaySelectProps) {
  return (
    <DateFieldInputRow item container>
      <Grid item xs={12} md={9}>
        <InputLabel shrink htmlFor={fieldId} sx={fieldCaptionLabelSx}>
          {caption}
        </InputLabel>
        <FormControl fullWidth variant="outlined" disabled={disabled}>
          <Select
            id={fieldId}
            value={value}
            onChange={onChange}
            disabled={disabled}
          >
            {WEEK_DAYS.map(code => (
              <MenuItem key={code} value={code}>
                {t(DAY_TRANSLATION_KEYS[code])}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <ScheduleSetTimeCaption caption={footerCaption} />
      </Grid>
    </DateFieldInputRow>
  )
}
